import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import { FilterOption, ReferralFilters as ReferralFiltersType } from '../types';

import classes from './referralFilters.module.css';

interface ReferralFiltersProps {
  filters: ReferralFiltersType;
  defaultFilters: ReferralFiltersType;
  companyOptions: FilterOption[];
  contactOptions: FilterOption[];
  onFilterChange: (key: keyof ReferralFiltersType, value: string) => void;
  onReset: () => void;
}

function ReferralFiltersComponent({
  filters,
  defaultFilters,
  companyOptions,
  contactOptions,
  onFilterChange,
  onReset,
}: ReferralFiltersProps) {
  const hasActiveFilters =
    filters.selectedCompany !== defaultFilters.selectedCompany ||
    filters.selectedContactId !== defaultFilters.selectedContactId ||
    filters.startDate !== defaultFilters.startDate ||
    filters.endDate !== defaultFilters.endDate;

  return (
    <div className={classes.filterCard}>
      <div className={classes.filterGrid}>
        <div className={classes.filterGroup}>
          <label htmlFor="companyFilter" className={classes.label}>
            Referring Company
          </label>
          <select
            id="companyFilter"
            className={`form-select ${classes.select}`}
            value={filters.selectedCompany}
            onChange={(e) => {
              onFilterChange('selectedCompany', e.target.value);
              // Reset contact filter when company changes
              onFilterChange('selectedContactId', '');
            }}
          >
            <option value="">All companies</option>
            {companyOptions.map((company) => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))}
          </select>
        </div>

        <div className={classes.filterGroup}>
          <label htmlFor="contactFilter" className={classes.label}>
            Referring Contact
          </label>
          <select
            id="contactFilter"
            className={`form-select ${classes.select}`}
            value={filters.selectedContactId}
            onChange={(e) => onFilterChange('selectedContactId', e.target.value)}
          >
            <option value="">All contacts</option>
            {contactOptions.map((contact) => (
              <option key={contact.id} value={contact.id}>
                {contact.name}
              </option>
            ))}
          </select>
        </div>

        <div className={classes.filterGroup}>
          <label htmlFor="startDate" className={classes.label}>
            Lead creation (from)
          </label>
          <input
            id="startDate"
            type="date"
            className={`form-control ${classes.dateInput}`}
            value={filters.startDate}
            onChange={(e) => onFilterChange('startDate', e.target.value)}
          />
        </div>

        <div className={classes.filterGroup}>
          <label htmlFor="endDate" className={classes.label}>
            Lead creation (to)
          </label>
          <input
            id="endDate"
            type="date"
            className={`form-control ${classes.dateInput}`}
            value={filters.endDate}
            onChange={(e) => onFilterChange('endDate', e.target.value)}
          />
        </div>

        <div className={classes.filterGroup}>
          <button
            type="button"
            className={`btn btn-link ${classes.resetButton}`}
            onClick={onReset}
            disabled={!hasActiveFilters}
          >
            Reset filters
          </button>
        </div>
      </div>
    </div>
  );
}

const ReferralFiltersMemo = memo(ReferralFiltersComponent, areEqual);

export { ReferralFiltersMemo as ReferralFilters };
